import { RedeemPackComponent } from './redeem-pack/redeem-pack.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { LoginComponent } from './login/login.component';
import { NgModule } from '@angular/core';

// import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/guard/auth.guard';

import { RouterModule, Routes, PreloadAllModules} from '@angular/router';
import { SplashComponent } from './splash/splash.component';

import { OnboardingComponent } from './onboarding/onboarding.component';
import { StartGameComponent } from './start-game/start-game.component';
import { QuestionComponent } from './question/question.component';
import { HomeComponent } from './home/home.component';
import { RedeemComponent } from './redeem/redeem.component';
import { SelfieComponent } from './selfie/selfie.component';
import { ProfileComponent } from './profile/profile.component';

const app_routes: Routes = [
  {
    path: "",
    component: SplashComponent
  },
 
  {
    path: "onboarding",
    component: OnboardingComponent
    

  },
  {
    path: "home",
    component: HomeComponent,
    canActivate: [AuthGuard],
     data: {animation: '*'}

  },
  {
    path: "start-game",
    component: StartGameComponent,
    canActivate: [AuthGuard],
     data: {animation: '*'}

  },
  {
    path: "question",
    component: QuestionComponent,
    canActivate: [AuthGuard],
     data: {animation: '*'}

  },
  {
    path: "redeem",
    component: RedeemComponent,
    canActivate: [AuthGuard],
     data: {animation: '*'}

  },
  {
    path: "redeem-pack",
    component: RedeemPackComponent,
    canActivate: [AuthGuard],
     data: {animation: '*'}

  },
  {
    path: "selfie",
    component: SelfieComponent,
    canActivate: [AuthGuard],
     data: {animation: '*'}
    
  },
  {
    path: "subscription",
    component: SubscriptionComponent,
    canActivate: [AuthGuard],
     data: {animation: '*'}
  },
  {
    path: "profile",
    component: ProfileComponent,
    canActivate: [AuthGuard],
     data: {animation: '*'}

  },
  {
    path: "login",
    component: LoginComponent, 

  },
  {
    // if path not found redirect to 404 page
    path: "**",
    redirectTo: "/"
  }
];

@NgModule({
    imports: [RouterModule.forRoot(app_routes, { preloadingStrategy: PreloadAllModules })], // [RouterModule.forRoot(routes)]
    exports: [RouterModule]
})
export class AppRoutingModule {
    
 }
